<template lang="pug">
    ul.hzStep
        li(v-for="(item, index) in items", v-html="item", :class="index <= current? 'active': ''")

</template>

<script>
    import DropDown from './dropdown';
    export default {
        name: 'hz-step',
        components: { DropDown },
        props: {
            items: null,
            current: { type: Number, default: 0 }
        }
    }
</script>

<style lang="stylus" scoped>
    .hzStep
        list-style-type none 
        display flex
        li 
            flex 1
            text-align center
            background-color #f0f0f0
            border 1px solid #ddd
            padding 0 20px 0 40px
            border-right 0
            position relative
            height 32px
            line-height 32px
            &:before, &:after
                z-index 1
                position absolute
                top 0
                left 100%
                content ""
                display inline-block
                border-style solid
                border-width 15px 0 15px 20px
                border-color transparent #ddd transparent
            &:after
                border-color transparent #f0f0f0 transparent
                margin-left -1px
            &:first-child
                padding-left 20px
            &:last-child
                border-right 1px solid #ddd
                &:before, &:after
                    display none
            &.active
                background-color #21d376
                color #fff
                &:after
                    border-color transparent #21d376 transparent
                    
</style>
            



// WEBPACK FOOTER //
// src/step.vue